import { setDeliveryMethod } from "action/shopping-cart/setDeliveryMethod";
import { updatePostalCode } from "action/shopping-cart/updatePostalCode";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import withErrorHandler from "component/design-system/withErrorHandler";
import { DELIVERY_METHODS } from "constant/action-constants";
import withShoppingCartState from "hoc/withShoppingCartState";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import qs from "query-string";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BOPISToolTip from "./BOPISToolTip";

const STORE_POSTAL_CODE = {
  mississauga: "L5T 1E4",
  edmonton: "T5S 2L5",
};

function BOPIS() {
  const dispatch = useDispatch();
  const { t } = useTranslation("product");
  const shoppingCart = useSelector((state: RootState) => state.shoppingCart);
  const { postalCode } = shoppingCart;
  const { store } = qs.parse(location.search);
  const isValidStore = store && STORE_POSTAL_CODE[store];
  const { availableDeliveryMethodsDetails } = shoppingCart;
  const pickupDetails = availableDeliveryMethodsDetails?.find((el) => el.deliveryMethod === DELIVERY_METHODS.PICKUP);
  const pickUpLocation = pickupDetails?.pickUpLocations?.[0];

  useEffect(() => {
    if (!isValidStore) {
      return;
    }
    // Don't set postalcode if alreay present in shoppingCart
    if (postalCode) {
      // Set delivery method to pickup if available
      if (pickupDetails) {
        dispatch(setDeliveryMethod(DELIVERY_METHODS.PICKUP));
      }
      return;
    }
    dispatch(updatePostalCode(STORE_POSTAL_CODE[store], { loader: false }));
    dispatch(setDeliveryMethod(DELIVERY_METHODS.PICKUP));
  }, []);

  if (!isValidStore) {
    return null;
  }

  if (!pickUpLocation) {
    return null;
  }

  return (
    <div className="d-flex">
      <PAText fontSize={FONT_SIZE[0]}>{t("Order Online and Pick Up at ")}</PAText>
      <BOPISToolTip showhelpText={false} />
    </div>
  );
}

export default withShoppingCartState(withErrorHandler(BOPIS));
